import type { ILeadScheduleAutoClosable } from '@user/store/lead/typings'

const SERVICE_SCHEDULED = 'Service Scheduled'

export type LeadAutoCloseGate = {
  /** The funnel opted in. The section renders nothing when false. */
  enabled: boolean
  /** Enabled, and no opportunity-required fields are outstanding. */
  applicable: boolean
  /** Every closing requirement other than `'Service Scheduled'` is satisfied. */
  requirementsMet: boolean
  /** The lead will be auto-closed/won by the commit. Drives the blue alert. */
  willAutoClose: boolean
  /** Closing requirements met, but opportunity-required fields are outstanding. Drives the red banner. */
  requiredFieldsAreMissing: boolean
  missingScheduleAutoCloseRequiredFields: number[]
}

const NOT_APPLICABLE: LeadAutoCloseGate = {
  enabled: false,
  applicable: false,
  requirementsMet: false,
  willAutoClose: false,
  requiredFieldsAreMissing: false,
  missingScheduleAutoCloseRequiredFields: [],
}

export function resolveLeadScheduleAutoClose(
  data: ILeadScheduleAutoClosable | undefined,
): LeadAutoCloseGate {
  if (!data) return NOT_APPLICABLE

  const {
    requirements,
    missingScheduleAutoCloseRequiredFields,
    funnelScheduleAutoCloseApplicable,
  } = data

  if (!funnelScheduleAutoCloseApplicable) return NOT_APPLICABLE

  const missingFields = missingScheduleAutoCloseRequiredFields ?? []

  const requirementsMet = !(requirements ?? []).some(
    (x) => x.type !== SERVICE_SCHEDULED,
  )

  const applicable = missingFields.length === 0

  return {
    enabled: true,
    applicable,
    requirementsMet,
    willAutoClose: applicable && requirementsMet,
    requiredFieldsAreMissing: missingFields.length > 0,
    missingScheduleAutoCloseRequiredFields: missingFields,
  }
}
